export const orderTypeOptions = {
  initial: 'initial',
  exchange: 'exchange',
}

export const orderTypeMenuItems = [
  {
    value: orderTypeOptions.initial,
    label: 'Pedido inicial',
  },
  {
    value: orderTypeOptions.exchange,
    label: 'Pedido de cambio',
  },
]
